import { useEffect, useMemo } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import PDFViewer from "../features/SelfAssessment/screens/Stepper/Pdf";

function parseAssessmentData(rawData) {
  if (!rawData) return {};
  try {
    return JSON.parse(rawData);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn("[assessment-report] invalid data query param:", error);
    return {};
  }
}

export default function AssessmentReportPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    document.title = "Report | PlacedRisk Solutions";
  }, []);

  const data = useMemo(() => {
    const raw = searchParams.get("data");
    return parseAssessmentData(raw);
  }, [searchParams]);

  return (
    <PDFViewer
      activeStep={0}
      handleBack={() => navigate("/Assessment")}
      handleNext={() => {}}
      data={data}
      setData={() => {}}
    />
  );
}
